Storage.prototype.getAll = function () {
	const values: Record<string, any> = {};
	for (let i = 0; i < this.length; i++) {
		const key = this.key(i);
		const value = this.getItem(key);
		values[key] = JSON.tryParse(value);
	}
	return values;
};

Storage.prototype.has = function (key: string) {
	return this.getItem(key) !== null;
};

export {};
